/* Keep motion controls usable after Shopify section reloads. */
if (!window.boujeeMotionControls) {
  window.boujeeMotionControls = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.boujee-shipping__pause');
    if (!button) return;
    const strip = button.closest('.boujee-shipping');
    const paused = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? 'Play shipping message' : 'Pause shipping message');
    button.textContent = paused ? 'Play' : 'Pause';
    strip.classList.toggle('is-paused', paused);
  });
}
